import { PartnersPaymentSummary, PartnersPaymentSummaryStatus } from 'gql/generated/graphql'
import { initDateByString } from 'utils/date'
import { FILE_CATEGORIES_LIST } from './constants'
import {
  IPaymentSummariesFormValues,
  IPaymentSummaryModel,
  IPaymentSummaryTimelineEventModel,
  IPaymentSummaryTimelineEventName,
  IPaymentSummaryTimelineEventType
} from './types'
import { isEmpty } from 'lodash'

export const createPaymentSummaryTimelineEventModel = (
  event: PartnersPaymentSummary['timeline'][0]
): IPaymentSummaryTimelineEventModel => {
  let eventName: IPaymentSummaryTimelineEventModel['name'] = event.type

  if (!isEmpty(event.action?.files)) {
    const firstFile = event.action?.files[0]
    eventName = firstFile?.category || ''
  } else {
    switch (event.type) {
      case IPaymentSummaryTimelineEventType.PartnersPaymentSummaryEmailRequested:
        eventName = IPaymentSummaryTimelineEventName.EmailSent
        break
      case IPaymentSummaryTimelineEventType.PartnersPaymentSummaryCreated:
        eventName = IPaymentSummaryTimelineEventName.PaymentSummaryCreated
        break
    }
  }

  return {
    id: event.id || '',
    correlationID: event.correlationID || '',
    type: event.type || '',
    createdAt: new Date(event.createdAt),
    user: {
      id: event.user.id || '',
      firstName: event.user.firstName || '',
      lastName: event.user.lastName || '',
      username: event.user.username || ''
    },
    name: eventName,
    action: {
      files:
        event.action?.files.map((file) => {
          return {
            id: file.id || '',
            category: file.category,
            path: file.path || '',
            errorPath: file.errorsFilePath || ''
          }
        }) || []
    }
  }
}

export const createPaymentSummaryModel = (data?: PartnersPaymentSummary): IPaymentSummaryModel => {
  return {
    id: data?.id || '',
    name: data?.name || '',
    status: (data?.status as PartnersPaymentSummaryStatus) || '',
    files:
      data?.files.map((file) => ({
        id: file.id || '',
        category: file.category,
        errorPath: file.errorsFilePath || ''
      })) || [],
    createdAt: data?.startDate ? (initDateByString(data?.startDate) as Date) : new Date(),
    timeline: data?.timeline?.map(createPaymentSummaryTimelineEventModel) || [],
    emails:
      data?.emails?.map((email) => ({
        id: email.id || '',
        address: email.address || '',
        status: email.status || '',
        reason: email.reason || '',
        updatedAt: new Date(email.updatedAt),
        partner: {
          id: email.partner.id || '',
          name: email.partner.name || ''
        }
      })) || []
  }
}

export const createPaymentSummaryFormValues = (data?: PartnersPaymentSummary): IPaymentSummariesFormValues => {
  return {
    name: data?.name || '',
    files: FILE_CATEGORIES_LIST.map((category) => {
      const file = (data?.files ?? []).find((item) => item.category === category)
      return {
        id: file?.id || '',
        category,
        name: '',
        file: '',
        path: '',
        errorPath: file?.errorsFilePath || ''
      }
    })
  }
}
